var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.5 20.5",
    style: {
      enableBackground: "new 0 0 20.5 20.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#827F83;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.8,19.5C4.4,19.5,0,15.2,0,9.8S4.4,0,9.8,0s9.8,4.4,9.8,9.8S15.2,19.5,9.8,19.5L9.8,19.5z M9.8,1.6 c-4.5,0-8.2,3.7-8.2,8.2S5.3,18,9.8,18S18,14.3,18,9.8S14.3,1.6,9.8,1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.7,20.5c-0.2,0-0.4-0.1-0.6-0.2L15.8,17c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l3.3,3.3 c0.3,0.3,0.3,0.8,0,1.1C20.1,20.4,19.9,20.5,19.7,20.5L19.7,20.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f995789b01156238e233fb6490cfe5cb.svg";
export { ForwardRef as ReactComponent };